module.exports = __webpack_public_path__ + "static/media/video1.dcaf3b44.mp4";